var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-main',[_c('v-container',{staticClass:"fill-height align-start pa-0",attrs:{"fluid":""}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{key:_vm.$route.fullPath,staticClass:"flex-grow-1"})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }